import { Component, OnInit } from '@angular/core';
import { HotparkingService, CommonService } from '../../services';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-hot-parking',
  templateUrl: './hot-parking.component.html',
  styleUrls: ['./hot-parking.component.css']
})
export class HotParkingComponent implements OnInit {
  companies = [];
  selectedCompany: any;
  carparkUsers = [];
  hotParkingList = [];
  selectedCarparkUser: any;

  cols = [
    { width: '5%',  header: 'Id',                  field: 'sdIdUser' },
    { width: '15%', header: 'Imię',                field: 'firstName' },
    { width: '15%', header: 'Nazwisko',            field: 'surname' },
    { width: '21%', header: 'Numer karty',         field: 'ticketNumber' },
    { width: '10%', header: 'SN karty',            field: 'serialNumber' },
    { width: '10%', header: 'Numer rejestracyjny', field: 'licensePlate' },
    { width: '10%', header: 'Ważne do',            field: 'validUntil' },
    { width: '10%', header: 'Obecny',              field: 'presentOnParking' },
    { width: '5%',  header: 'Akcja',               field: 'action' }
  ];

  constructor(
    private hotParkingService: HotparkingService,
    private commmonsService: CommonService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.hotParkingService.getPermittedCompanies().subscribe(companies => {
      this.companies = companies.map(company => {
        return { label: company.name, value: company };
      });
    });
  }

  onCompanyChange(event) {
    this.refreshCarparkUsers();
  }

  private refreshCarparkUsers() {
    console.log("refreshCarparkUsers", this.selectedCompany);
    if (this.selectedCompany) {
      this.hotParkingService.getHotParkingList(this.selectedCompany.id).subscribe(hpls => {
        this.hotParkingList = hpls;
        this.commmonsService.getCarparkUsers(this.selectedCompany.id).subscribe(users => {
          this.carparkUsers = users.filter(user => !this.hotParkingList.some(hpl => hpl.sdIdUser == user.userNo))
            .map(user => {
              return { label: user.userFirstName + ' ' + user.userSurname + ' | nr karty ' + user.serialNo, value: user };
            });
        });
      });
    }
  }

  deleteHotParkingPosition(hotParkingPosition) {
    this.hotParkingService.deleteHotParkingCard(hotParkingPosition.id).subscribe(
      () => {
        this.messageService.add({ severity: 'success', summary: 'Usunięcie karty z listy HotParking', detail: 'Karta została usunięta z listy Hot Parking' });
        this.refreshCarparkUsers();
      },
      (error) => this.messageService.add({ severity: 'error', summary: 'Błąd usuwania karty z listy Hot Parking', detail: error.headers['code'] })
    );
  }

  addHotParkingPosition() {
    console.log(this.selectedCarparkUser);
    if (this.selectedCarparkUser == null) {
      return;
    } 
    this.hotParkingService.addHotParkingCard(this.selectedCarparkUser.userNo).subscribe(
      () => {
        this.messageService.add({ severity: 'success', summary: 'Usunięcie karty z listy HotPrking', detail: 'Dodano kartę do listy Hot Parking' });
        this.refreshCarparkUsers();
      },
      (error) => this.messageService.add({ severity: 'error', summary: 'Błąd dodawania karty do listy Hot Parking', detail: error.headers['code'] })
    );
  }

}
